export default theme => ({
  root: {
    //Cambia estilo base, por custom
    /* borderBottom: `1px solid ${theme.palette.border}`, */
    borderBottom: `0px solid ${theme.palette.border}`,

    //Cambia estilo base, por custom
    //backgroundColor: theme.palette.common.white,
    backgroundColor: '#333333',
    display: 'grid',
    alignItems: 'center',
    height: '100px',
    zIndex: theme.zIndex.appBar
  },
  centerText:{
    textAlign:"center"
  },
  toolbar: {
    minHeight: 'auto',
    width: '100%'
  },
  toolbarMenu: {
    position: "absolute",
    top: "50px",
    right: "0px",
  },
  title: {
    marginLeft: theme.spacing(1),
    //Cambia estilo base, por custom
    color: '#ffffff'
  },
  rowPop:{
    color:"white",
    paddingLeft:"10px"
  },
  subtitle: {
    marginLeft: theme.spacing(1),
    //Cambia estilo base, por custom
    color: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  menuButton: {
    marginLeft: '-4px',
    color: '#b2b2b2'
  },
  popOverStatus:{
    overflowY:"hidden !important",
    overflow:"hidden !important",
    "&.MuiPopover-paper": {
      overflowY:"hidden !important",
      overflow:"hidden !important"
    },
},
 textCenter:{
   textAlign:"center"
 },
  userInfoButton: {
    color: '#b2b2b2',
  },
  FeedbackButton: {
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
    },
    color: '#e6e6e6',
  },
  signOutButton: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1),
    },
    color: '#b2b2b2',
  },
  customBadgeOnline: {
    backgroundColor: '#7CFC00',
    color: 'white',
  },
  customBadgeOnlineUp: {
    backgroundColor: 'rgb(160, 246, 92)',
    color: 'white',
  },

  customBadgeOnlineDown: {
    backgroundColor: 'rgb(255, 96, 89)',
    color: 'white',
  },
  customBadgeOnlinePartial: {
    backgroundColor: 'rgb(254, 254, 25)',
    color: 'white',
  },
  customBadgeOnlineNoMon: {
    backgroundColor: 'rgb(241, 241, 241)',
    color: 'white',
  },
  customBadgeMargin: {
    margin: theme.spacing(2)
  },
  // Custom Style
  serviceInfo: {
    color: '#bdd63b',

  },
  serviceInfoArrow: {
    color: '#bdd63b',
    height: '20px',
    width: '20px',
    padding: 'bottom'

    
  },
  FeedBackSaveBack:{
    backgroundColor:"white",
    width:"70%",
  },
  FeedBack:{
    width:"63%",
    backgroundColor:"white"
  },
  comment:{
    border:"1px solid #e0e0e0"
  },
     //Agrega Custom ScrollBar
     customScrollBar: {
      '&::-webkit-scrollbar': {
          width: '0.4em',
      },
      '&::-webkit-scrollbar-track': {
          '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
      },
      '&::-webkit-scrollbar-track-piece': {
          background: '#525252'
      },
      '&::-webkit-scrollbar-thumb:horizontal': {
          background: '#E5E5E5',
          },
      '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(245,112,0,.8)',
          outline: '1px solid slategrey'
      }
    } 
  
});
